import paynovusLogo from '@/assets/paynovus-logomark.svg';
import { cn } from '@/lib/utils';

interface BrandedSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  text?: string;
}

export function BrandedSpinner({ size = 'md', className, text }: BrandedSpinnerProps) {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
  };

  const ringClasses = {
    sm: 'w-10 h-10',
    md: 'w-14 h-14',
    lg: 'w-20 h-20',
  };

  return (
    <div className={cn("flex flex-col items-center gap-3", className)}>
      <div className="relative flex items-center justify-center">
        {/* Spinning ring - positioned relative to container */}
        <div 
          className={cn(
            "absolute rounded-full border-2 border-accent/20 border-t-accent animate-spin",
            ringClasses[size]
          )}
        />
        {/* Logo in center */}
        <div 
          className={cn(
            "relative rounded-xl bg-background flex items-center justify-center z-10",
            sizeClasses[size]
          )}
        >
          <img 
            src={paynovusLogo} 
            alt="PayNovus" 
            className={cn(
              "object-contain animate-pulse",
              size === 'sm' ? 'h-5' : size === 'md' ? 'h-7' : 'h-10'
            )} 
          />
        </div>
      </div>
      {text && (
        <p className="text-sm font-medium text-foreground animate-pulse">{text}</p>
      )}
    </div>
  );
}
